<template>
    <section class="dashboard new-updated-design">
        <div class="dashb1">Dashboard</div>
        <div class="row">
            <div class="col-md-4">
                <div class="widget widget-stat bg-inverse text-white">
                    <div class="widget-stat-btn"><a @click.prevent="dashboardCount('members')" ><i class="fa fa-repeat"></i></a>
                    </div>
                    <div class="widget-stat-icon"><i class="fa fa-users"></i></div>
                    <div class="widget-stat-info">
                        <div class="widget-stat-title">Members</div>
                        <div class="widget-stat-number">{{ count.members }}</div>
                        <div class="widget-stat-text"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="widget widget-stat bg-success1 text-white">
                    <div class="widget-stat-btn"><a @click.prevent="dashboardCount('rsvp')" ><i class="fa fa-repeat"></i></a>
                    </div>
                    <div class="widget-stat-icon"><i class="fa fa-calendar"></i></div>
                    <div class="widget-stat-info">
                        <div class="widget-stat-title">RSVP</div>
                        <div class="widget-stat-number">{{ count.rsvp }}</div>
                        <div class="widget-stat-text"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="widget widget-stat bg-primary1 text-white">
                    <div class="widget-stat-btn"><a @click.prevent="dashboardCount('referrals')" ><i class="fa fa-repeat"></i></a>
                    </div>
                    <div class="widget-stat-icon"><i class="fa fa-sitemap"></i></div>
                    <div class="widget-stat-info">
                        <div class="widget-stat-title">Referrals</div>
                        <div class="widget-stat-number">{{ count.referrals }}</div>
                        <div class="widget-stat-text"></div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
import API from '../api';

export default {
    name: 'Dashboard',
    components: {
    },
    data() {
        return {
            count: {
                members: 0,
                rsvp: 0,
                referrals: 0
            },
            form: {
                date_from: '',
                date_to: '',
            }
        };
    },
    methods: {
        dashboardCount(refresh = 'count') {
            API.dashboardCount(res => {
                if (refresh === 'count') {
                    this.count = res.data;
                } else {
                    this.count[refresh] = res.data[refresh]
                }
            }, err => {
                console.log(err);
            })
        },
        resetForm() {
            this.form.date_from = '';
            this.form.date_to = '';
        },
        getPermissions() {
            this.getPermissionsData = JSON.parse(localStorage.getItem('userPermissions'));
        },
        permissionExist(param) {
            var check = this.getPermissionsData.includes(param);
            if (check) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted() {
        this.dashboardCount()
    }, beforeMount() {
        this.getPermissions();
    },
}
</script>
